import { ClientAttachmentId, ClientItemId } from 'owa-client-ids';
import AttachmentOperationType from 'owa-service/lib/contract/AttachmentOperationType';
import CheckPendingAttachmentOperationResponse from 'owa-service/lib/contract/CheckPendingAttachmentOperationResponse';
import { action } from 'satcheljs';

const checkPendingAttachmentOperation = action(
    'checkPendingAttachmentOperation',
    (
        attachmentId: ClientAttachmentId,
        itemId: ClientItemId,
        operationId: string,
        operationType: AttachmentOperationType,
        completeHandler: (response: CheckPendingAttachmentOperationResponse) => void
    ) => ({
        attachmentId: attachmentId,
        itemId: itemId,
        operationId: operationId,
        operationType: operationType,
        completeHandler: completeHandler,
    })
);

export default checkPendingAttachmentOperation;
